import { Controller } from "@hotwired/stimulus"

// Le panneau « Voir ce qui est fait » de la page Cycle de vie (Insurance::Catalog::Lifecycle::PanelComponent).
//
// - À chaque envoi d'un formulaire « Voir ce qui est fait » (form[data-lifecycle-detail-form], hors du panneau, qui vise
//   sa frame), le contenu affiché est remplacé tout de suite par le squelette d'attente : l'ancien contenu ne réapparaît
//   jamais, même une fraction de seconde.
// - Le dernier clic gagne : la réponse d'un formulaire envoyé avant le dernier est écartée (turbo:before-fetch-response,
//   annulable, émis sur le formulaire), même si elle arrive après.
export default class extends Controller {
  static targets = ["frame", "skeleton"]

  connect() {
    this.onSubmit = (event) => this.submitted(event)
    this.onResponse = (event) => this.responded(event)
    // En capture : avant que Turbo prenne l'envoi en charge.
    document.addEventListener("submit", this.onSubmit, true)
    document.addEventListener("turbo:before-fetch-response", this.onResponse)
  }

  disconnect() {
    document.removeEventListener("submit", this.onSubmit, true)
    document.removeEventListener("turbo:before-fetch-response", this.onResponse)
  }

  submitted(event) {
    const form = this.detailForm(event.target)
    if (!form) return

    this.lastForm = form
    this.frameTarget.replaceChildren(this.skeletonTarget.content.cloneNode(true))
  }

  responded(event) {
    const form = this.detailForm(event.target)
    if (form && this.lastForm && form !== this.lastForm) event.preventDefault()
  }

  detailForm(target) {
    return target instanceof HTMLFormElement && target.matches("[data-lifecycle-detail-form]") ? target : null
  }
}
